module.exports = __webpack_public_path__ + "img/compliance_logo.ec259184.png";